import React from "react";
import { NavLink } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const TABS = [
  { to: "/trade-global", key: "mt_us", slug: "us" },
  { to: "/trade-gcc", key: "mt_me", slug: "middle-east" },
  { to: "/trade-eu", key: "mt_eu", slug: "europe" },
  { to: "/trade-asia", key: "mt_asia", slug: "asia" },
  { to: "/trade-world", key: "mt_world", slug: "world" },
  { to: "/trade-forex", key: "mt_fx", slug: "forex" },
  { to: "/trade-commodities", key: "mt_comm", slug: "commodities" },
  { to: "/trade-crypto", key: "mt_crypto", slug: "crypto" },
];

const cls = ({ isActive }) =>
  `shrink-0 px-3.5 h-9 inline-flex items-center rounded-full text-sm transition-colors ${
    isActive
      ? "bg-card text-foreground font-semibold shadow-premium"
      : "text-muted-foreground hover:text-foreground font-medium"
  }`;

/** Shared Markets tab family, rendered at the top of every market page. */
export const MarketsTabs = () => {
  const { t } = useApp();
  const tabs = TABS;
  return (
  <div className="mb-4 sm:mb-5 -mx-1 px-1 overflow-x-auto no-scrollbar" data-testid="markets-tabs">
    <div className="inline-flex items-center gap-1 rounded-full border border-border/70 bg-secondary/50 p-1">
      {tabs.map((tab) => (
        <NavLink key={tab.to} to={tab.to} className={cls}
          data-testid={`markets-tab-${tab.slug}`}>
          {t(tab.key)}
        </NavLink>
      ))}
    </div>
  </div>
  );
};
